<script>
const icons = require.context('@assets/images/', false, /\.svg$/);

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
        type: [Number, Array],
        required: false,
        default: 18
    }
  },
  computed: {
    style() {
      return {
        backgroundImage: 'url(' + icons('./' + this.name + '.svg') + ')',
        height: (Array.isArray(this.size)? this.size[0] : this.size) + 'px',
        width: (Array.isArray(this.size)? this.size[1] : this.size) + 'px'
      };
    }
  }
}
</script>
<template>
  <i :class="$style.icon" :style="style" v-on="$listeners"></i>
</template>
<style lang="scss" module>
@import '@design';
.icon {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  line-height: inherit;
}
</style>